// export const environment = {
//   REACT_APP_Identity_Microservice_URL: 'https://identity.wajeez.com/',
//   REACT_APP_Content_Microservice_URL: 'https://content.wajeez.com/',
//   REACT_APP_Payment_Microservice_URL: 'https://payment.wajeez.com/',
//   REACT_APP_Engagement_Microservice_URL: 'https://engagement.wajeez.com/',
//   REACT_APP_Media_Microservice_URL: 'https://media.wajeez.com/',
//   REACT_APP_APP_WATCH_MICROSERVICE_URL: 'https://api.wajeez.com/',
//   REACT_APP_DataTable: 'muiDataTable',
// };

const baseUrl = 'https://dev.wajeez.com/';
// const baseUrl = 'https://api.wajeez.com/';
// const baseUrl = 'http://localhost:5270/';

export const environment = {
  REACT_APP_Identity_Microservice_URL: baseUrl,
  REACT_APP_Content_Microservice_URL: baseUrl,
  REACT_APP_Payment_Microservice_URL: baseUrl,
  REACT_APP_Affiliate_Microservice_URL: 'https://payment-webhook.wajeez.com',
  REACT_APP_Engagement_Microservice_URL: baseUrl,
  REACT_APP_Media_Microservice_URL: baseUrl,
  // REACT_APP_Media_UPLOAD_Microservice_URL: "http://dev.media.wajeez.com/",
  REACT_APP_Media_UPLOAD_Microservice_URL: baseUrl,
  REACT_APP_APP_WATCH_MICROSERVICE_URL: baseUrl,
  REACT_APP_DataTable: 'muiDataTable',
  REACT_APP_Web_App: 'https://app.dev.wajeez.com',
};
